import { useState } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "@mui/material";
import AssistantAvatar from "./AssistantAvatar";
import { markIntroSeen, OPEN_PROFILE_EVENT, useAgentNews } from "./agentNews";
import LendyIntro from "./profile/LendyIntro";
// The profile's intro dot and intro screen, which the new chat reuses.
import "./profile/lendyProfile.css";
import "./profile/lendyIntro.css";
import "./welcomeAvatar.css";

/**
 * The new chat's avatar, with the profile's brand dot. It pulses while there's something new on
 * the assistant: a "Say hi" not opened yet (the click opens it), or news in its profile (the click
 * opens the profile).
 */
const WelcomeAvatar = ({ assistantName, imageUrl }) => {
  const [isIntroOpen, setIsIntroOpen] = useState(false);
  const { isIntroNew, hasInboxNews, hasNews } = useAgentNews();
  const opensProfile = hasInboxNews && !isIntroNew;

  const open = () => {
    if (opensProfile) {
      window.dispatchEvent(new Event(OPEN_PROFILE_EVENT));

      return;
    }
    markIntroSeen();
    setIsIntroOpen(true);
  };
  const label = opensProfile ? `${assistantName} has something new for you` : `What ${assistantName} can do`;

  return (
    <>
      {/* Above the face: below it, it would cover the agent switcher. */}
      <Tooltip title={label} placement="top" arrow>
        <button type="button" className="aav2-welcome-face" aria-label={label} onClick={open}>
          <AssistantAvatar imageUrl={imageUrl} size="welcome" />
          <span className={`lendy-intro-dot aav2-welcome-dot${hasNews ? " lendy-ping" : ""}`} aria-hidden="true">
            <i />
          </span>
        </button>
      </Tooltip>
      {isIntroOpen &&
        createPortal(
          <div className="lendy-intro-screen">
            <LendyIntro
              assistantName={assistantName}
              assistantImageUrl={imageUrl}
              backLabel="Back to chat"
              onBack={() => setIsIntroOpen(false)}
            />
          </div>,
          document.body
        )}
    </>
  );
};

export default WelcomeAvatar;
